import { Injectable } from '@angular/core';
import { IconName } from '../models/icon.model';

@Injectable({
    providedIn: 'root',
})
export class SocialMediaIconService {
    getIconName = (itemType: string): IconName => {
        switch (itemType) {
            case 'facebook':
                return 'facebook_logo_duotone';
            case 'instagram':
                return 'instagram_logo_duotone';
            case 'linkedin':
                return 'linkedin_logo_duotone';
            case 'twitter':
            case 'x':
                return 'x_logo_duotone';
            case 'youtube':
                return 'youtube_logo_duotone';
            case 'tiktok':
                return 'tiktok_logo_duotone';
            case 'wechat':
                return 'wechat_logo_duotone';
            case 'weishi':
                return 'weishi_logo_duotone';
            case 'shipinhao':
                return 'shipinhao_logo_duotone';
            default:
                return 'sparkle_duotone';
        }
    };
}
